// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { setSessionStorage, getSessionStorage } from '@tcp/core/src/utils/utils.web';
import { parseBoolean, getIconPath } from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblSiteCookiesDisclaimer,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';

import styles, {
  CookiesDisclaimerContainer,
  DisclaimerTextContainer,
  ButtonContainer,
} from '../styles/SiteCookiesDisclaimer.style';

const SiteCookiesDisclaimer = ({ className }) => {
  const globalGenericLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );

  const siteCookiesDisclaimer = renderLabel(
    globalGenericLabels[lblSiteCookiesDisclaimer],
    'lbl_site_cookies_disclaimer'
  );
  const [disclaimerClosed, setDisclaimerClosed] = useState(true);
  useEffect(() => {
    const isDisclaimerClosed = parseBoolean(getSessionStorage('cookies-disclaimer-closed'));
    if (!isDisclaimerClosed) {
      setDisclaimerClosed(false);
    }
  }, []);

  const handleCloseDisclaimer = () => {
    setDisclaimerClosed(true);
    setSessionStorage({ key: 'cookies-disclaimer-closed', value: true });
  };

  return (
    !disclaimerClosed && (
      <CookiesDisclaimerContainer className={`hide-on-native-web-view ${className}`}>
        <DisclaimerTextContainer>
          <BodyCopy
            fontSize={['fs12', 'fs14', 'fs14']}
            fontWeight="regular"
            fontFamily="secondary"
            color="gray.800"
            className="disclaimer-text-container"
          >
            {siteCookiesDisclaimer}
          </BodyCopy>
        </DisclaimerTextContainer>
        <ButtonContainer
          onClick={handleCloseDisclaimer}
          onKeyDown={handleCloseDisclaimer}
          role="button"
          tabIndex={0}
          className="close-icon-container"
        >
          <img
            alt="close"
            className="close-icon"
            src={getIconPath('modal-close')}
            width={15}
            height={15}
          />
        </ButtonContainer>
      </CookiesDisclaimerContainer>
    )
  );
};

SiteCookiesDisclaimer.propTypes = {
  className: PropTypes.string,
};

SiteCookiesDisclaimer.defaultProps = {
  className: '',
};

export default withStyles(SiteCookiesDisclaimer, styles);
export { SiteCookiesDisclaimer as SiteCookiesDisclaimerVanilla };
